import React from 'react';
import { ShieldCheck, Lock, CreditCard } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function Hero() {
  return <section className="bg-[#0B0B12] text-white pt-0 pb-8 px-4 md:pt-4 md:pb-16 overflow-hidden relative bg-premium-gradient" data-id="element-167">
      <div className="blur-circle bg-brand-gold/20 -top-20 -right-20" data-id="element-168" />
      <div className="blur-circle bg-brand-primary/10 -bottom-20 -left-20" data-id="element-169" />
      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-170">
        <div className="animate-fadeInUp" data-id="element-171">
          <div className="inline-block bg-brand-gold/10 text-brand-gold px-4 py-1.5 rounded-full text-[10px] font-black mb-2 border border-brand-gold/20 tracking-[0.2em] uppercase mt-4" data-id="element-172">
            ✨ SISTEMA PROFESIONAL PARA ESTILISTAS, PELUQUERAS Y DUEÑAS DE SALÓN
          </div>

          <h1 className="md:text-6xl lg:text-7xl font-black mb-1 px-0 text-white uppercase text-[20px] tracking-tight" data-id="element-173">
            💥 DEJÁ DE IMPROVISAR EN TU PELUQUERÍA Y EMPEZÁ A{' '}
            <span className="gold-text-gradient" data-id="element-174">
              TRABAJAR CON ESTRUCTURA PROFESIONAL.
            </span>
          </h1>

          <div className="relative mb-0 max-w-2xl mx-auto" data-id="element-175">
            <div className="absolute inset-0 bg-brand-primary/5 blur-[100px] rounded-full scale-75 pointer-events-none" data-id="element-176" />
            <img src="https://cdn.magicpatterns.com/uploads/f3mdkUQPLoA4EHusbTnVEV/MOCKUP1_600x.png" alt="MegaPack Peluquería Lista Mockup" className="w-full h-auto relative z-10 mockup-glow" fetchPriority="high" decoding="async" width="600" height="450" data-id="element-177" />
          </div>

          <p className="md:text-xl font-medium mb-6 max-w-2xl mx-auto text-slate-400 text-[15px] leading-relaxed" data-id="element-178">
            Todo listo para usar. Sistema profesional organizado y listo para
            aplicar desde hoy.
          </p>

          <CTAButton text="QUIERO ACCESO INMEDIATO" className="w-auto mx-auto mb-8 shadow-2xl shadow-brand-gold/10" data-id="element-179" />

          <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-3 text-xs md:text-sm text-slate-500 font-bold uppercase tracking-wider" data-id="element-180">
            <div className="flex items-center gap-2" data-id="element-181">
              <ShieldCheck size={18} className="text-brand-primary" data-id="element-182" />
              <span data-id="element-183">Garantía 7 días </span>
            </div>
            <div className="flex items-center gap-2" data-id="element-184">
              <Lock size={18} className="text-brand-primary" data-id="element-185" />
              <span data-id="element-186">Pago 100% seguro</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-187">
              <CreditCard size={18} className="text-brand-primary" data-id="element-188" />
              <span data-id="element-189">Pagás en pesos argentinos</span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}